/**
 * End Equipment Reference Designs (EERD) API
 * Team: Product and Systems Path Virtual Team
 * Date: 06/2019
 * Version: 1.2
 * Latest:
 * Products and reference designs items are now side-by-side instead of tabbed view
 * EERD width now spans 1920px max
 */

if (!window.com)
	com = new Object();
if (!com.TI)
	com.TI = new Object();
if (!com.TI.diagramManager)
	com.TI.diagramManager = new Object();

var variantJSON,
	getFormatRequestSuccess = function (d) {
		document.getElementById("format").value = d.format;

		if (d.format === "") {
			document.getElementsByClassName("legend-box")[0].parentNode.children[1].innerHTML =
			document.getElementsByClassName("legend-box")[0].parentNode.children[1].innerHTML + "THERE IS NO DATA";
		}

		cleanup();
		reload();

		if (document.getElementById("format").value === "") {
			document.getElementsByClassName("legend-box")[0].parentNode.children[1].innerHTML =
			document.getElementsByClassName("legend-box")[0].parentNode.children[1].innerHTML + "THERE IS NO DATA";
		}

	},

	selectVariant = function (e) {
		document.getElementById("eeqId").value = e.value;

		function checkForFunction(retryCount) {
			if (typeof _tiAnalyticsTrack !== "undefined") {
				_tiAnalyticsTrack('eerd', 'variant selection', $("#website").val() + "_eerd_" + e.value + "_variant");
			} else {
				if (retryCount < 5) {
					retryCount++;
					setTimeout(function () {
						checkForFunction(retryCount);
					}, 1250);
				}
			}
		}

		checkForFunction(0);

		$.ajax({
			url: "/wsapi/solution/eeqId/" + e.value + "/format",
			selectValue: e,
			type: "get",
			dataType: "json",
			success: getFormatRequestSuccess
		});

		var variant_id = document.getElementById("eeqId").value;
		var sschkA1 = $(".diagram-box").find("[class*='subsys default enabled']").attr("data-subsystem-id");
		var ss_id;

		if (sschkA1){
			ss_id = sschkA1;
		} else {
			var ref_link = $(".diagram-box").find("[class*='default']").attr("data-reference-link");
			if(ref_link !== undefined){
				ss_id = ref_link.match("subsystemId/(.*)/rdproductlist")[1];
			}
		}
		setVariantUrl(variant_id, ss_id, false);
	},

	cleanup = function () {
		document.getElementById("eerd-display").innerHTML = "";
	},

	reload = function () {
		putDiagramOnPage();
	};

com.TI.diagramManager = function (opts) {
	var $ = jQuery,
		option, $elem, Interface,
		base_layout, Text, Layout, Region,
		Link_ID, Version, Row_icon, fallback_text, svc_util,
		svcUrl, $eerd_display, Is_test, eerdID,
		rd = {},
		defaults = {
			id: "",
			elem: "[data-diagram-id]",
			display_version: "b",
			region: "en",
			ee: "",
			data: {},
			config: {},
			test: "false"
		};


	option = $.extend({}, defaults, opts);
	$eerd_display = $(option.id);
	eerdID = option.ee;
	$elem = $(option.elem);
	Is_test = option.test;
	Region = option.region;
	Interface = option.config;
	Layout = Interface.layout;
	Version = option.display_version;
	base_layout = Layout.base;
	Text = Interface.text[Region];
	Link_ID = Interface.link_id;
	Row_icon = Interface.row_icons;
	fallback_text = {
		ref_designs: Text.ref_designs.fallback,
		products: Text.ti_prod.fallback
	};

	svc_util = {
		region: option.region,
		eeqId: option.ee
	};

	svcUrl = {
		A1: {
			diagram: {
				file: Is_test === "test" ? option.data.A1.diagram.test_file : option.data.A1.diagram.file,
				subsyslist: Is_test === "test" ? option.data.A1.diagram.test_subsyslist : option.data.A1.diagram.subsyslist
			},
			productlist: Is_test === "test" ? option.data.A1.test_productlist : option.data.A1.productlist
		},
		A2: {
			subsyslist: option.data.A2.subsyslist,
			productlist: option.data.A2.productlist
		},
		B: {
			productlist: option.data.B.productlist
		}
	};

	rd.linkid_region = Link_ID.region;
	rd.rootUrl = Interface.option.url;
	rd.select_class = "ti-custom-dropdown SumoUnder";

	function buildA1VariantSelect() {
		var options = "";
		variantJSON.map(function (e) {
			options += '<option value="' + e.vId + '" ' + ((e.vId == eerdID) ? "selected" : "") + '>' + e.vName + "</option>";
		});

		var select = "<select id='variantselect' class='" + rd.select_class + "' onchange='selectVariant(this)'>" + options + " </select>";

		$eerd_display.removeClass("version-a2").addClass("version-a1");

		Layout.A1.diagram_container = Layout.A1.diagram_container
			.replace("{{diagram_variant_select}}", select);
	}

	function buildA2VariantSelect() {
		var options = "";
		variantJSON.map(function (e) {
			options += '<option value="' + e.vId + '" ' + ((e.vId == eerdID) ? "selected" : "") + '>' + e.vName + "</option>";
		});

		var select = "<select id='variantselect' class='" + rd.select_class + "' onchange='selectVariant(this)'>" + options + " </select>";

		$eerd_display.removeClass("version-a1").addClass("version-a2");

		Layout.A2.diagram_container = Layout.A2.diagram_container
			.replace("{{diagram_variant_select}}", select);
	}

	function subsystemListClickEventHandler(e) {
		e.stopPropagation();
		e.preventDefault();
		var $currtarget = $(e.currentTarget),
			$curr_url = $currtarget.data("reference-link");

		$currtarget.closest("[data-diagram-id]")
			.find(".default")
			.removeClass("default");

		$currtarget.addClass("default");

		//set variant url for subsystem select
		var	ref_link = $currtarget.attr("data-reference-link");
		if(ref_link !== undefined){
			var subsystem_id = ref_link.match("subsystemId/(.*)/rdproductlist")[1];
			setVariantUrl(document.getElementById("eeqId").value, subsystem_id, false);
		}
		buildRefDesignProductList({
			el: $currtarget,
			url: $curr_url
		});
	}

	function buildA2SubsystemList(i, d) {
		var subsys = d,
			lid = Link_ID.A2,
			lid_region = rd.linkid_region[Region],
			default_class = subsys.defaultSubSystem === "true" ? "default" : "",
			subsystemlinkid = lid.subsys
				.replace("{{eename}}", svc_util.eeqId)
				.replace("{{subsysname}}", subsys.subSystemId)
				.replace("{{linkid_region}}", lid_region),
			subsys_url_id = svcUrl.A2.productlist
				.replace("{{product_id}}", subsys.subSystemId),
			row = Layout.ee_list_row
				.replace("{{subsysurl}}", subsys_url_id)
				.replace("{{subsysid}}", convertDataName(subsys.subSystemName))
				.replace("{{subsystem_label}}", subsys.subSystemName)
				.replace("{{subsystem_linkid_list}}", subsystemlinkid)
				.replace("{{is_default}}", subsys.defaultSubSystem)
				.replace("{{default_class}}", default_class);

		$(row).appendTo($("[data-diagram-id]").find("ul"));
		return i;
	}

	/**
	 * Procedure to convert data name variable to follow data-attribute convention
	 * @param name
	 * @returns {string|*}
	 */
	function convertDataName(name) {
		var str = name.split(/[\s\/]/g), //matches space
			_name;

		_name = str.join("-").toLowerCase();
		_name = _name.split(/[=<>(^\]*,)\/]/g); //matches parentheses
		_name = _name.join("");
		_name = _name.split(/-&(?:[a-z]+|#\d+);|-&/g); //matches "&" and HTML special characters (&amp; &reg; &trade; &copy; etc)
		_name = _name.join("");
		_name = _name.split(/-;-/g);
		_name = _name.join("-");
		_name = _name.split(/[&ltg;]/g);
		_name = _name.join("");
		_name = _name.split(/[\+]*/g); //matches "+" plus sign
		_name = _name.join("");
		return _name;
	}

	function chapterNavManager() {
		var chapter_nav = ".ti-chapter-nav",
			smoothAnchorScrollEvent = function (e) {
				if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
					var target = $(this.hash);
					target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

					if (target.length) {
						$('html, body').animate({
							scrollTop: target.offset().top - 80
						}, 500);
						window.location.hash = this.hash;
						return false;
					}
				}
			},
			stickyNav = function () {
				var stickyNavTop = $(chapter_nav).offset().top,
					scrollTop = $(window).scrollTop();

				if (scrollTop > stickyNavTop) {
					$(chapter_nav).addClass('is-sticky');
				} else if ( scrollTop === 0) {
					$(chapter_nav).removeClass('is-sticky');
				}
			},
			chapterNavSticky = function () {
				var nav = document.querySelector(chapter_nav);
				if (nav && nav.hasAttribute('data-ti-sticky')) {
					stickyNav();

					$(window).scroll(function () {
						stickyNav();
					});
				}
			},
			anchorTrigger = function () {
				var section = document.querySelectorAll('.js-scrollspy');
				var sections = {};
				var i = 0;

				Array.prototype.forEach.call(section, function (e) {
					sections[e.id] = e.offsetTop - 100; // offsets start of anchor trigger
				});

				window.onscroll = function () {
					var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;

					for (i in sections) {
						if (sections[i] <= scrollPosition) {
							if (document.querySelector(".ti-chapter-nav li.active") !== null) {
								document.querySelector(".ti-chapter-nav li.active").classList.remove("active");
							}
							if (document.querySelector(".ti-chapter-nav a[href*='" + i + "']") !== null) {
								document.querySelector(".ti-chapter-nav a[href*='" + i + "']").parentElement.classList.add("active");
							}
							if (document.querySelector(".ti-chapter-nav span a[href*='" + i + "']") !== null) {
								document.querySelector(".ti-chapter-nav span a[href*='" + i + "']").parentElement.parentElement.classList.add("active");
							}
						}
					}
				};
			},
			chapterNavHighlightEvent = function (e) {
				var a = $(e),
					selector = document.querySelector(".ti-chapter-nav li.active");

				setTimeout(function () {
					if (selector !== null) {
						selector.classList.remove("active");
					}
					a.parentElement.classList("active");
				}, 500);
			};

		if (document.querySelector("[data-ti-sticky]")) {
			chapterNavSticky();
			anchorTrigger();
		}

		$(".ti-chapter-nav li", document).on("click", "a", smoothAnchorScrollEvent);
		$(".js-chapterNav", document).on("click", "a", chapterNavHighlightEvent);
	}

	/**
	 * Manages the display of the overall EERD canvas based on what data is returned or not
	 * @param flag
	 * @returns {boolean}
	 */
	var displaySectionDescription = {
		v1: function (flag) {
			var section_header = Layout.section_header1
					.replace("{{section_header_title}}", Text.section_header_title)
					.replace("{{section_description}}", Text.section_description),
				$h2_section_header = $("h2.eerd-section-header");

			if (!flag) {
				//If no data is returned to remove section header and disable anchorlink
				$eerd_display.remove();
				$h2_section_header.remove();
				return false;

			} else if (flag) {
				//Converts linking anchorlink to enable item
				$("#referencedesignprodlink").html(anchorLinkManager);

				//If data to expand container and add section title and enable anchorlink
				$eerd_display.addClass("expand");

				if ($h2_section_header.length < 1) {
					$(section_header).insertBefore($eerd_display, document);
				}
			}
		},
		v2: function (flag) {
			var section_header = Layout.section_header2
					.replace("{{section_header_title}}", Text.section_header_title),
				section_desc_box = Layout.section_desc_box
					.replace("{{section_description}}", Text.section_description),
				$h2_section_header = $("h2.eerd-section-header"),
				$section_description = $h2_section_header.siblings("[data-section-description]");

			if (!flag) {
				//If no data is returned to remove section header and disable anchorlink
				$eerd_display.remove();
				$h2_section_header.remove();
				return false;

			} else if (flag) {
				//Converts linking anchorlink to enable item
				$("#referencedesignprodlink").html(anchorLinkManager);

				//If data to expand container and add section title and enable anchorlink
				$eerd_display.addClass("expand");

				if ($section_description.length < 1) {
					$h2_section_header.html(section_header);
					$(section_desc_box).insertAfter($h2_section_header);
				}
			}
		}
	};

	/**
	 * Manages the 'active' and 'deactivated' state of the page table of content anchorlink for Reference Design & products
	 * @returns {string|*}
	 */
	function anchorLinkManager() {
		var anchor;

		anchor = Layout.anchor_link
			.replace("{{anchorlink}}", "#" + encodeURI(Interface.text.anchor_link))
			.replace("{{linkid_region}}", Link_ID.region[Region])
			.replace("{{anchorlink_label}}", $(this).text());

		return anchor;
	}

	/**
	 * Builds HTML for list of both Reference Design & Products list items
	 * @param obj
	 */
	function buildRefDesignProductList(obj) {
		var image_box, rd_primary_row, rd_secondary_row, prod_primary_row,
			prod_secondary_row, cell_row, diag_data, rdlink, prodlink,
			lregion = rd.linkid_region[Region],
			$product_details_box = $("[data-diagram-type='product-details']"),
			data_linkid = $product_details_box.find("ul.subsys-tabs"),
			data_linkid_eename = data_linkid.data("linkid-eename"),
			data_linkid_subsysname = data_linkid.data("linkid-subsysname"),
			ref_design_tab = responsiveRefDesignTabTitle(),
			box_header_title = "Sub System",
			box_body = Layout[Version].box_body
				.replace("{{ref_design_title}}", ref_design_tab)
				.replace("{{eename}}", data_linkid_eename)
				.replace("{{subsysname}}", data_linkid_subsysname)
				.replace("{{ti_prod_title}}", Text.ti_prod.tab)
				.replace("{{subsystem_title}}", box_header_title)
				.replace("{{read_description}}", Text.read_description),
			view_more_container,
			view_less_container,
			cnt = 0,
			getTabContentHeight = function () {
				var parent_height = parseInt($product_details_box.height()),
					headline_height = parseInt($product_details_box.find(".headline-header").height()),
					tab_content_height = parent_height - headline_height;

				$product_details_box.find(".ref-designs, .ti-products").height(tab_content_height);
			},
			/**
			 * Ajax success callback procedure
			 * @param d
			 */
			getProdDetailsRequestSuccess = function (d) {
				/**
				 * Procedure for "reference_designs" data object return
				 * @param i
				 * @param r
				 */
				var getReferenceDesignData = function (i, r) {
						if (r && !$.isEmptyObject(r)) {
							if (typeof r.rdImageUrl === "undefined" || r.rdImageUrl === "") {
								image_box = Layout[Version].image_box.fallback;
							} else {
								image_box = Layout[Version].image_box.src.replace("{{row_image}}", r.rdImageUrl);
							}

							rdlink = {
								tab: "&lid=en_US_eerd_A1_{{eename_rd}}_{{subsysname_rd}}_refdesigns_tab",
								image: lid.ref_designs.image
									.replace("{{eename}}", eerdID)
									.replace("{{subsysname}}", diag_data.subsystemId)
									.replace("{{tpn}}", r.rdPartNumber)
									.replace("{{linkid_region}}", lregion),
								text: lid.ref_designs.text
									.replace("{{eename}}", eerdID)
									.replace("{{subsysname}}", diag_data.subsystemId)
									.replace("{{tpn}}", r.rdPartNumber)
									.replace("{{linkid_region}}", lregion),
								more: lid.ref_designs.more
									.replace("{{eename}}", eerdID)
									.replace("{{subsysname}}", diag_data.subsystemId)
									.replace("{{tpn}}", r.rdPartNumber)
									.replace("{{linkid_region}}", lregion),
								less: lid.ref_designs.less
									.replace("{{eename}}", eerdID)
									.replace("{{subsysname}}", diag_data.subsystemId)
									.replace("{{tpn}}", r.rdPartNumber)
									.replace("{{linkid_region}}", lregion),
								schematic: lid.ref_designs.schematic
									.replace("{{eename}}", eerdID)
									.replace("{{subsysname}}", diag_data.subsystemId)
									.replace("{{tpn}}", r.rdPartNumber)
									.replace("{{linkid_region}}", lregion),
								reference_guide: lid.ref_designs.reference_guide
									.replace("{{eename}}", eerdID)
									.replace("{{subsysname}}", diag_data.subsystemId)
									.replace("{{tpn}}", r.rdPartNumber)
									.replace("{{linkid_region}}", lregion),
								view_folder: lid.ref_designs.view_folder
									.replace("{{eename}}", eerdID)
									.replace("{{subsysname}}", diag_data.subsystemId)
									.replace("{{tpn}}", r.rdPartNumber)
									.replace("{{linkid_region}}", lregion)
							};

							view_more_container = Layout.view_more_container
								.replace("{{linkid_more}}", rdlink.more)
								.replace("{{view_more}}", Text.view_more);

							rd_primary_row = Layout[Version].ref_design_cell_row.cell_row_primary_level
								.replace("{{row_url}}", r.rdtoolUrl)
								.replace("{{row_name}}", r.rdTitle)
								.replace("{{view_more_container}}", view_more_container)
								.replace("{{ref_designs_linkid_text}}", rdlink.text)
								.replace("{{ref_new_label}}", r.isNew === "Y" ? Layout.ref_new_label: "")
								.replace("{{labelnew}}", Text.labelnew);

							rd_secondary_row = Layout[Version].ref_design_cell_row.cell_row_secondary_level
								.replace("{{row_url2}}", r.rdtoolUrl)
								.replace("{{row_url3}}", r.rdtoolUrl)
								.replace("{{row_desc1}}", r.rdDesc)
								.replace("{{row_image}}", r.rdImageUrl)
								.replace("{{reference_guide}}", r.referenceGuideValue)
								.replace("{{diagram}}", r.schematicValue)
								.replace("{{cta_text1}}", Text.ref_designs.cta[0])
								.replace("{{cta_text2}}", Text.ref_designs.cta[1])
								.replace("{{cta_text3}}", Text.ref_designs.cta[2])
								.replace("{{eename2}}", eerdID)
								.replace("{{subsysname2}}", diag_data.subsystemId)
								.replace("{{tpn2}}", r.rdPartNumber)
								.replace("{{ref_designs_linkid_image}}", rdlink.image)
								.replace("{{ref_designs_linkid_schematic}}", rdlink.schematic)
								.replace("{{ref_designs_linkid_referenceguide}}", rdlink.reference_guide)
								.replace("{{ref_designs_linkid_viewfolder}}", rdlink.view_folder)
								.replace("{{image_box}}", image_box)
								.replace("{{icon.schematic_diagram}}", Row_icon.schematic_diagram)
								.replace("{{icon.reference_guide}}", Row_icon.reference_guide)
								.replace("{{icon.reference_design}}", Row_icon.reference_design);

							cell_row = Layout[Version].ref_design_row
								.replace("{{cell_row_primary_level}}", rd_primary_row)
								.replace("{{cell_row_secondary_level}}", rd_secondary_row);

							if (r.rdTitle && r.rdTitle.length > 0) {
								$product_details_box.find(".ref-design-count span").html(i += 1);
								$(cell_row).appendTo($(".assoc-list-container .ref-designs"));
							}
						}
					},
					/**
					 * Formats data for product family grouping
					 * @param prodData
					 * @returns {{}}
					 */
					groupProductsByFamily = function (prodData) {
						var prod_data = productsDataFormat(prodData) || {},
							$ti_products = $(".assoc-list-container .ti-products"),
							boolean = true,
							group = {},
							obj = {},
							result = [],
							groupmember,
							x;

						$.each(prod_data, function (i, item) {
							if (!group[item.gpnTopLevelFamily]) {
								group[item.gpnTopLevelFamily] = [];
							}

							Object.keys(item).forEach(function (property) {
								if (item[property] === "") {
									if (property !== "gpnDesc" && property !== "gpnSampleBuy" && property !== "gpnOnlineDatasheet") {
										boolean = false;
									}
								}
							});

							if (boolean) {
								group[item.gpnTopLevelFamily].push({
									gpnPartNumber: item.gpnPartNumber,
									gpnTitle: item.gpnTitle,
									gpnDesc: item.gpnDesc,
									gpnUrl: item.gpnUrl,
									gpnDiagram: item.gpnDiagram,
									gpnSampleBuy: item.gpnSampleBuy,
									gpnOnlineDatasheet: item.gpnOnlineDatasheet,
									gpnDatasheet: item.gpnDatasheet,
									subFamilyId: item.subFamilyId,
									subFamily: item.subFamily,
									gpnTopLevelFamily: item.gpnTopLevelFamily,
									isNew: item.isNew
								});
							}
						});

						for (x in group) {
							obj[x] = group[x];
							result.push(obj);
							groupmember = group[x];
							var subFamilyList = [];

							groupmember.forEach(function (item) {
								if (!subFamilyList.filter(function (subFamilyList) {
										return item.subFamily === subFamilyList.subFamily;
									})[0]) {
									return subFamilyList.push({
										subFamily: item.subFamily,
										subFamilyData: groupmember.filter(function (filtereditem) {
											return filtereditem.subFamily === item.subFamily;
										})
									});
								}
							});

							if (groupmember.length > 0) {
								var prod_fam_data = $("[data-diagram-type='product-details']").data(),

									prod_fam_linkid = Link_ID[Version].product_family_header
										.replace("{{eename}}", prod_fam_data.eeId)
										.replace("{{subsysname}}", prod_fam_data.subsysId)
										.replace("{{linkid_region}}", lregion)
										.replace("{{source}}", rd.data_source)
										.replace("{{productFamily}}", convertDataName(x)),

									container = Layout.family_group_container
										.replace("{{family_group_id}}", convertDataName(x))
										.replace("{{family_group_name}}", x)
										.replace("{{count}}", groupmember.length)
										.replace("{{linkid_product_family}}", prod_fam_linkid)
										.replace("{{linkid_more_product_family}}", prod_fam_linkid);

								// var temp =
								$(container).appendTo($ti_products).data("groupCount", groupmember.length);
								subFamily(subFamilyList, convertDataName(x));
								//to open the first product in each family
							}
						}

						return group;
					},
					//Formats data for SubFamily in Product tab
					subFamily = function (subFamilyList, name) {
						var $id = $("#" + name);
						var $product_subfamily_list = $id.find("[data-product-subfamily-list]");
						for (var index = 0; index < subFamilyList.length; index++) {
							var prod_fam_data = $("[data-diagram-type='product-details']").data(),
								prod_fam_linkid = Link_ID[Version].product_subfamily_header
								.replace("{{eename}}", prod_fam_data.eeId)
								.replace("{{subsysname}}", prod_fam_data.subsysId)
								.replace("{{linkid_region}}", lregion)
								.replace("{{source}}", rd.data_source)
								.replace("{{productFamily}}", convertDataName(subFamilyList[index].subFamily)),
								compare_linkid = Link_ID[Version].compare_header
								.replace("{{linkid_region}}",lregion)
								.replace("{{eename}}", prod_fam_data.eeId)
								.replace("{{subsysname}}", prod_fam_data.subsysId)
								.replace("{{source}}", rd.data_source)
								.replace("{{subFamilyId}}", subFamilyList[index].subFamilyData[0].subFamilyId),

								container1 = Layout.subfamily_group_container
								.replace("{{subfamily_group_id}}", convertDataName(subFamilyList[index].subFamily))
								.replace("{{sub_family_group_name}}", subFamilyList[index].subFamily)
								.replace("{{count}}", subFamilyList[index].subFamilyData.length)
								.replace("{{linkid_product_family}}", prod_fam_linkid)
								.replace("{{expandcount}}", subFamilyList.length < 2 ? "expand" : "")
								.replace("{{linkid_more_product_family}}", prod_fam_linkid)
								.replace("{{compare_Url}}",comparefunction(subFamilyList[index].subFamilyData,lregion))
								.replace("{{linkid_compare}}",compare_linkid)
								.replace("{{compare_text}}", Text.compare_text)
								.replace("{{show_compare}}", subFamilyList.length < 2 && subFamilyList[index].subFamilyData.length > 1 ? "show" : "")
								.replace("{{show_subfamily}}", subFamilyList.length < 2 ? "expand" : "")
								.replace("{{new_label}}", subFamilyList.isNew === "Y" ? Layout.new_label: "")
								.replace("{{labelnew}}", Text.labelnew);;

							var subfamily_row = Layout.subfamily_cell
								.replace("{{subfamilydiv}}", container1);
							$(subfamily_row).appendTo($product_subfamily_list);
							productFamilyMap(subFamilyList[index].subFamilyData, convertDataName(subFamilyList[index].subFamily));
						}
					},
					/**
					 * Builds the HTML layout for product family grouping
					 * @param grp
					 * @param name
					 * @returns {Array|*}
					 */
					productFamilyMap = function (grp, name) {
						var groupmap,
							$id = $("#" + convertDataName(name)),
							$product_family_list = $id.find("[data-product-family-list]"),
							buildProductRows = function (p) {
								if (p && !$.isEmptyObject(p)) {
									if (typeof p.gpnDiagram === "undefined" || p.gpnDiagram === "") {
										image_box = Layout[Version].image_box.fallback;
									} else {
										image_box = Layout[Version].image_box.src.replace("{{row_image}}", p.gpnDiagram);
									}

									prodlink = {
										tab: lid.products.tab
											.replace("{{eename_prod}}", eerdID)
											.replace("{{subsysname}}", diag_data.subsystemId)
											.replace("{{linkid_region}}", lregion)
											.replace("{{source}}", rd.data_source),
										image: lid.products.image
											.replace("{{eename}}", eerdID)
											.replace("{{subsysname}}", diag_data.subsystemId)
											.replace("{{gpn}}", p.gpnPartNumber)
											.replace("{{linkid_region}}", lregion)
											.replace("{{source}}", rd.data_source),
										text: lid.products.text
											.replace("{{eename}}", eerdID)
											.replace("{{subsysname}}", diag_data.subsystemId)
											.replace("{{gpn}}", p.gpnPartNumber)
											.replace("{{linkid_region}}", lregion)
											.replace("{{source}}", rd.data_source),
										more: lid.products.more
											.replace("{{eename}}", eerdID)
											.replace("{{subsysname}}", diag_data.subsystemId)
											.replace("{{gpn}}", p.gpnPartNumber)
											.replace("{{linkid_region}}", lregion)
											.replace("{{source}}", rd.data_source),
										less: lid.products.less
											.replace("{{eename}}", eerdID)
											.replace("{{subsysname}}", diag_data.subsystemId)
											.replace("{{gpn}}", p.gpnPartNumber)
											.replace("{{linkid_region}}", lregion)
											.replace("{{source}}", rd.data_source),
										download_datasheet: lid.products.download_datasheet
											.replace("{{eename}}", eerdID)
											.replace("{{subsysname}}", diag_data.subsystemId)
											.replace("{{gpn}}", p.gpnPartNumber)
											.replace("{{linkid_region}}", lregion)
											.replace("{{source}}", rd.data_source),
										online_datasheet: lid.products.online_datasheet
											.replace("{{eename}}", eerdID)
											.replace("{{subsysname}}", diag_data.subsystemId)
											.replace("{{gpn}}", p.gpnPartNumber)
											.replace("{{linkid_region}}", lregion)
											.replace("{{source}}", rd.data_source),
										order_now: lid.products.order_now
											.replace("{{eename}}", eerdID)
											.replace("{{subsysname}}", diag_data.subsystemId)
											.replace("{{gpn}}", p.gpnPartNumber)
											.replace("{{linkid_region}}", lregion)
											.replace("{{source}}", rd.data_source)
									};

									view_more_container = Layout.view_more_container
										.replace("{{linkid_more}}", prodlink.more)
										.replace("{{view_more}}", Text.view_more);

									prod_primary_row = Layout[Version].product_cell_row.cell_row_primary_level
										.replace("{{row_name}}", p.gpnTitle)
										.replace("{{row_url}}", p.gpnUrl)
										.replace("{{row_desc}}", p.gpnTitle)
										.replace("{{row_gpn}}", p.gpnPartNumber)
										.replace("{{products_linkid_text}}", prodlink.text)
										.replace("{{view_less_container}}", view_less_container)
										.replace("{{view_more_container}}", view_more_container)
										.replace("{{new_label}}", p.isNew === "Y" ? Layout.new_label: "")
										.replace("{{labelnew}}", Text.labelnew);

									prod_secondary_row = Layout[Version].product_cell_row.cell_row_secondary_level
										.replace("{{row_url2}}", p.gpnUrl)
										.replace("{{row_image}}", p.gpnDiagram)
										.replace("{{download_datasheet}}", p.gpnDatasheet)
										.replace("{{online_datasheet}}", p.gpnOnlineDatasheet)
										.replace("{{row_description}}", p.gpnDesc)
										.replace("{{order}}", p.gpnSampleBuy)
										.replace("{{cta_text1}}", Text.ti_prod.cta[0])
										.replace("{{cta_text2}}", Text.ti_prod.cta[1])
										.replace("{{cta_text3}}", Text.ti_prod.cta[2])
										.replace("{{eename2}}", eerdID)
										.replace("{{subsysname2}}", diag_data.subsystemId)
										.replace("{{gpn2}}", p.gpnPartNumber)
										.replace("{{products_linkid_image}}", prodlink.image)
										.replace("{{products_linkid_downloaddatasheet}}", prodlink.download_datasheet)
										.replace("{{products_linkid_onlinedatasheet}}", prodlink.online_datasheet)
										.replace("{{products_linkid_ordernow}}", prodlink.order_now)
										.replace("{{image_box}}", image_box)
										.replace("{{icon.order_now}}", Row_icon.order_now)
										.replace("{{icon.online_datasheet}}", Row_icon.online_datasheet)
										.replace("{{icon.download_datasheet}}", Row_icon.download_datasheet);

									cell_row = Layout[Version].product_row
										.replace("{{cell_row_primary_level}}", prod_primary_row)
										.replace("{{cell_row_secondary_level}}", prod_secondary_row);

									$product_details_box
										.find(".ti-product-count span")
										.html(cnt += 1);

									$(cell_row).appendTo($product_family_list);
								}
							};

						groupmap = $.map(grp, buildProductRows);
						return groupmap;
					};

				//Data object is different between A1/A2 and B versions. This logic reflects that
				if (Version === "A1" || Version === "A2") {
					diag_data = d.EndEquipmentSubSystemRdProduct;
				} else {
					diag_data = d.EndEquipmentRefDesignProducts;
				}

				//Displays End Equipment Display description
				var toggle = !(diag_data[0] && diag_data[0].errorCode);
				displaySectionDescription.v2(toggle);

				if (diag_data && !$.isEmptyObject(diag_data)) {
					var ref_design_fallback = Layout.fallback_box.replace("{{fallback_text}}", fallback_text.ref_designs),
						ti_prod_fallback = Layout.fallback_box.replace("{{fallback_text}}", fallback_text.products),
						headline_box,
						$box_body,
						lid = Link_ID[Version],
						rdtab,
						prodtab;

					rdtab = lid.ref_designs.tab
						.replace("{{eename}}", eerdID)
						.replace("{{subsysname}}", diag_data.subsystemId)
						.replace("{{linkid_region}}", lregion);

					//rdproductlist response - source: EMSG=1 vs JACK recommendation=2
					rd.data_source = diag_data.prdSrc ? diag_data.prdSrc : 1;

					prodtab = lid.products.tab
						.replace("{{eename}}", eerdID)
						.replace("{{subsysname}}", diag_data.subsystemId)
						.replace("{{linkid_region}}", lregion)
						.replace("{{source}}", rd.data_source);


					$box_body = box_body
						.replace("{{ref_designs_linkid_tab}}", rdtab)
						.replace("{{products_linkid_tab}}", prodtab);


					$("[data-diagram-sub-system]").html($product_details_box);
					$product_details_box.data({
						"subsysname": diag_data.subsystemName,
						"subsysId": diag_data.subsystemId,
						"eeId": eerdID
					});

					$product_details_box.addClass("show").html($box_body);

					if (Version === "A1" || Version === "A2") {
						headline_box = Layout[Version].headline_desc
							.replace("{{subsystem_desc}}", diag_data.subsystemDesc);

						if (diag_data.subsystemName && diag_data.subsystemName.length > 0) {
							$product_details_box
								.find("h4")
								.text(diag_data.subsystemName);
						}

						if (diag_data.subsystemDesc && diag_data.subsystemDesc.length > 0) {
							$(headline_box).insertAfter(".description-link");
						}
					}

					//Reference Design Data list
					if (!isArrayEmpty(diag_data.referenceDesigns)) {
						$.each(refDesignDataFormat(diag_data.referenceDesigns), getReferenceDesignData);
						defaultOpenCellRowRefDesign($product_details_box.find(".ref-designs"));
					} else {
						$("[data-prod-details-tab='ref-designs']")
							.addClass("disabled")
							.prop("disabled", true)
							.attr("disabled", true);

						$product_details_box.find(".ti-products");

						$product_details_box.find(".ref-designs").html(ref_design_fallback);
					}

					//Products Data list
					if (!isArrayEmpty(diag_data.products)) {
						groupProductsByFamily(diag_data.products);
						defaultOpenCellRowProducts($product_details_box.find(".ti-products"));
					} else {
						$("[data-prod-details-tab='ti-products']")
							.addClass("disabled")
							.prop("disabled", true)
							.attr("disabled", true);

						$product_details_box
							.find(".ti-products")
							.html(ti_prod_fallback);
					}

					$("ul.assoc-list-tabs", document)
						.on("click", "[data-prod-details-tab] a", productBoxTabClickEventHandler);

					getTabContentHeight();

					$(".description-link", document).on("click", descriptionLinkClickEventHandler);

					$(".ref-designs", document)
						.on("click", ".more-container a", subSystemRowClickEventHandler);

					$(".ti-products", document)
						.on("click", ".expandproduct", productListExpandToggle)
						.on("click", "[data-subfamily-cta='compare']", subFamilyCompareClickEventHandler)
						.on("click", "[data-subfamily-cta='search-all']", subFamilySearchAllClickEventHandler)
						.on("click", ".family-group-header", productHeaderExpandToggle);

					$($product_details_box.find(".ti-products")).scroll(productTabScroll);

				}

				chapterNavManager();
			};

		$product_details_box.removeClass("show");
		$eerd_display.find("[data-diagram-sub-system]").html(Layout.loader);

		if (obj.url) {
			$.ajax({
				url: obj.url,
				type: "get",
				dataType: "json",
				success: getProdDetailsRequestSuccess,
				error: function () {
					function errorMessage() {
						$("[data-diagram-sub-system]").html("<p style='background-color: rgba(255, 51, 51, 0.1);'>There are currently no products or reference designs available.  Please select another subsystem</p>");
					}

					setTimeout(errorMessage, 500);
					chapterNavManager();
				}
			});
		}
	}

	function comparefunction(subFamily_list, lregion) {
		if (subFamily_list.length > 1) {
			var familyId = subFamily_list[0].subFamilyId;
			var partId = "";
			var lang = "";
			for (var i = 0; i < subFamily_list.length; i++) {
				if (i === (subFamily_list.length) - 1) {
					partId = partId + subFamily_list[i].gpnPartNumber;
				} else {
					partId = partId + subFamily_list[i].gpnPartNumber + ",";
				}
			}
			if (lregion.substring(0, 2) === "en") {
				lang = "en";
			} else if (lregion.substring(3) === "jp") {
				lang = "jp";
			} else {
				lang = "cn";
			}
			var compareUrl = "/assets/js/compareParts/compare.html?familyId=" + familyId + "&parts=" + partId + "&lang=" + lang;
		}
		return compareUrl;
	}
	/**
	 * The purpose for this is to output an alternative text string version for device view
	 * @returns {string|string|string}
	 */
	function responsiveRefDesignTabTitle() {
		return Text.ref_designs.tab.desktop;
	}

	/**
	 * jQuery click event handler for product tab scrolling
	 * @param e
	 */
	function productTabScroll(e) {
		var headers = $(".family-group-header").toArray();
		var index = 0;
		headers.map(function (header, idx) {
			if (header.offsetTop + 10 < e.currentTarget.scrollTop && !$(header).hasClass('subfamily')) {
				index = idx;
			}
		});

		var stickyHeader = headers[index],
			$sticky = $("#sticky");

		if (stickyHeader.innerText.indexOf("expand_less") !== -1) {
			var offset = $(".ref-designs, .ti-products").offsetTop;

			$sticky.css("top", offset + "px");
			$sticky.addClass("visible");

			$sticky[0].innerHTML = stickyHeader.children[0].innerText + " " + stickyHeader.children[1].innerText;
		} else {
			$sticky.removeClass("visible");
			$sticky.html("ERROR WITH STICKY HEADER");
		}

		if (e.currentTarget.scrollTop < 3) {
			$sticky.removeClass("visible");
		}

	}

	function descriptionLinkClickEventHandler(e) {
		e.preventDefault();
		e.stopPropagation();

		var el = $(e.currentTarget);
		if (!el.next().hasClass("show")) {
			el.next().addClass("show");
			el.find(".material-icons").addClass("collapse");
		} else {
			el.next().removeClass("show");
			el.find(".material-icons").removeClass("collapse");
		}
	}

	/**
	 * jQuery click event handler for associated product header element/expansion
	 * @param e
	 */
	function productHeaderExpandToggle(e) {
		e.stopPropagation();
		var $el = $(e.currentTarget),
			$compare_button = $el.find("[data-subfamily-cta='compare']"),
			$search_button = $el.find("[data-subfamily-cta='search-all']"),
			linkid = $el.attr("name"),
			lid = linkid ? linkid.split("&lid=")[1] : "",
			$prod_family_list = $el.find("[data-product-family-list]"),
			len = $prod_family_list.find(".cell-row").length,
			$target = $(e.target);

		if (e.target === this || $target.hasClass("sub-header") || $target.hasClass("group-title") || $target.hasClass("header-desc") || $target.hasClass("header-buttons") || $target.hasClass("group-count") || $target.hasClass("material-icons")) {
			e.preventDefault();

			if ($el.hasClass("subfamily")) {
				if (len > 1) { //If there are more than one product listing in Subfamily show buttons
					if ($compare_button.hasClass("show")) {
						$compare_button.removeClass("show");
					} else {
						$compare_button.addClass("show");
					}
				}

					if ($search_button.hasClass("show")) {
					$search_button.removeClass("show");
					} else {
					$search_button.addClass("show");
					}

				if (!$target.closest(".family-group-header").find("[data-product-family-list]").hasClass("expand")) {
					$target.addClass("expanded").parent().addClass("expand").find("[data-product-family-list]").addClass("expand");
					$target.closest(".family-group-header").addClass("expand").find(".sub-header").addClass("expanded").find("[data-product-family-list]").addClass("expand");
					$target.closest(".family-group-header").find("span.more-container-product a").find(".material-icons").addClass("collapse");
					} else {
					$target.removeClass("expanded").parent().removeClass("expand").find("[data-product-family-list]").removeClass("expand");
					$target.closest(".family-group-header").removeClass("expand").find(".sub-header").removeClass("expanded").find("[data-product-family-list]").removeClass("expand");
					$target.closest(".family-group-header").find("span.more-container-product a").find(".material-icons").removeClass("collapse");
					}
				}

			if ($target.hasClass("subshow") || $target.hasClass("header-desc") || $target.hasClass("header-buttons")) {
			if (!$el.find("[data-product-family-list]").hasClass("expand")) {
				$el.find("[data-product-family-list]").addClass("expand");
				$el.find("span.more-container-product a").find(".material-icons").addClass("collapse");
			} else {
				$el.find("[data-product-family-list]").removeClass("expand");
					$el.find("span.more-container-product a").find(".material-icons").removeClass("collapse");
				}
			} else {
				if (!$el.find("[data-product-subfamily-list]").hasClass("expand")) {
					$el.find("[data-product-subfamily-list]").addClass("expand");
					$el.find("span.show a").find(".material-icons").addClass("collapse");
				} else {
					$el.find("[data-product-subfamily-list]").removeClass("expand");
					$el.find("span.show a").find(".material-icons").removeClass("collapse");
				}
			}
		}

		_tiAnalyticsTrack("Link Track", lid, tiPageName, tiContentGroup);
	}

	function productListExpandToggle(e) {
		e.stopPropagation();
		var $el = $(e.currentTarget),
			$point_target = $(e.target),
			$row = $el.closest(".lvl.primary"),
			$target = $row.siblings(".lvl.secondary"),
			$cell_row = $row.parent();

		if (!$row.hasClass("expandproduct")) {
			$row = $el.find(".lvl.primary");
			$target = $row.siblings(".lvl.secondary");
			$cell_row = $row.parent();
		}

		if ($el.hasClass("expandproduct")) {

			if (!$target.hasClass("show")) {
				$target.addClass("show");
				$cell_row.addClass("expanded");
			} else {
				$target.removeClass("show");
				$cell_row.removeClass("expanded");
			}

			if ($point_target.hasClass("material-icons")) {
				e.preventDefault();
				if (!$point_target.hasClass("collapse")) {
					$point_target.addClass("collapse");
					setTimeout(function () {
						$target.css("overflow", "visible");
					}, 200);
				} else {
					$point_target.removeClass("collapse");
					$target.css("overflow", "hidden");
				}
			}
		}
	}

	function subFamilyCompareClickEventHandler(e) {
		e.preventDefault();
		var $el = $(e.currentTarget),
			compareUrl = $el.data("compare-url"),
			popupWindow = window.open(compareUrl, "Compare", "height=800,width=800,modal=yes,alwaysRaised=yes,location=0,status=no,menubar=no,resizable=yes,scrollbars=yes");
		popupWindow.focus();
		e.stopPropagation();

	}

	function subFamilySearchAllClickEventHandler(e) {
		e.preventDefault();
		e.stopPropagation();
		window.location.href = "http://www.ti.com";
	}
	/**
	 * jQuery click event handler for associated reference designs/product list element
	 * @param e
	 */
	function subSystemRowClickEventHandler(e) {
		e.stopPropagation();
		e.preventDefault();
		var $el = $(e.currentTarget),
			$row = $el.closest(".lvl.primary"),
			$target = $row.siblings(".lvl.secondary"),
			$cell_row = $row.parent(),
			attr = $el.attr("name"),
			attr_less = attr.replace("_more", "_less");

		if (!$target.hasClass("show")) {
			$target.addClass("show");
			$cell_row.addClass("expanded");
			$el.attr({
				"name": attr_less,
				"title": Text.view_less
			});
		} else {
			$target.removeClass("show");
			$cell_row.removeClass("expanded");
			$el.attr({
				"name": attr_less,
				"title": Text.view_more
			});
		}

		if (!$el.find(".material-icons").hasClass("collapse")) {
			$el.find(".material-icons").addClass("collapse");
			setTimeout(function () {
				$target.css("overflow", "visible");
			}, 200);
		} else {
			$el.find(".material-icons").removeClass("collapse");
			$target.css("overflow", "hidden");
		}
	}

	/**
	 * Associated reference design & product tab event handler
	 * @param e
	 */
	function productBoxTabClickEventHandler(e) {
		e.stopPropagation();
		e.preventDefault();
		var $curr_target = $(e.currentTarget).parent(),
			prod_details_tab = $curr_target.data("prod-details-tab"),
			link = $curr_target.find("a").attr("name"),
			impression_id = link ? link.split("&lid=")[1] : "",
			prod_details_class = "." + prod_details_tab;

		if (prod_details_tab === 'ti-products') {
			//not adding it here because we only want to do it for expanded product families
			//$("#sticky")[0].classList.add("visible")
		} else {
			if (!($("#format").val() === "B")) {
				$("#sticky")[0].classList.remove("visible");
			}
		}

		if (!$curr_target.hasClass("disabled")) {
			$curr_target
			//.addClass("active")
				.siblings()
			//.removeClass("active");

			$curr_target
				.closest("[data-diagram-type]")
				.find(prod_details_class)
				//.addClass("active")
				.siblings()
			//.removeClass("active");
		}

		if (prod_details_tab === "ti-products") {
			//Metrics for Jack/EMSG impressions
			_tiAnalyticsTrack('eerd', 'impression', impression_id);
		}

		$curr_target.closest("[data-diagram-type]").find(prod_details_class).scrollTop(0);

		document.querySelectorAll('[data-group-container]')[0].children[2].children[0].children[0].classList.add = "collapse"
		document.querySelectorAll('[data-group-container]')[0].children[3].classList.add("expand")
	}

	/**
	 * Data mapping exceptions from subsystemlist JSON data service
	 * @param subsys
	 * @returns {Array|*}
	 */
	function subSystemListDataFormat(subsys) {
		var mObj = function (slist) {
				slist.subsystemName = slist.subsystemName ? slist.subsystemName : Text.fallback.subsystemName;
				slist.subsystemDesc = slist.subsystemDesc ? slist.subsystemDesc : "";
				return slist;
			},
			list_map;

		list_map = $.map(subsys, mObj);
		return list_map;
	}

	/**
	 * Data mapping exceptions from rdproductlist JSON data service
	 * @param refd
	 * @returns {Array|*}
	 */
	function refDesignDataFormat(refd) {
		var mappedObj = function (o) {
				o.rdDesc = o.rdDesc ? textTrim(o.rdDesc) : "";
				return o;
			},
			map;

		if (!refd) return false;
		map = $.map(refd, mappedObj);
		return map;
	}

	/**
	 * Data mapping exceptions from productlist JSON data service
	 * @param p
	 * @returns {Array|*}
	 */
	function productsDataFormat(p) {
		var pMapObj = function (o) {
				o.gpnDesc = o.gpnDesc ? textTrim(o.gpnDesc) : "";
				return o;
			},
			data_map;

		if (!p) return false;
		data_map = $.map(p, pMapObj);
		return data_map;
	}

	/**
	 * Procedure to expand first associated subsystem reference designs/products list
	 * @param elem
	 */
	function defaultOpenCellRowRefDesign(elem) {
		var $container = $(elem),
			$row = $container.find(".cell-row").first(),
			more_container = $row.find(".lvl.primary .more-container"),
			attr = more_container.find("a").attr("name"),
			$data_group_container = $("[data-group-container]").first();

		var new_attr = attr.replace("_more", "_less"),
			$secondary_row = $row.find(".lvl.secondary");

		$row.addClass("expanded");
		$data_group_container.find(".more-container-product .material-icons").addClass("collapse");
		more_container.find("i").addClass("collapse");
		more_container.find("a").attr({
			"name": new_attr,
			"title": Text.view_less
		});
		//more_container.find("span").text(Text.view.less);
		$secondary_row.addClass("show").css("overflow", "visible");
	}

	function defaultOpenCellRowProducts(elem) {
		var $elem = $(elem),
			$product_family_group = $elem.find("[data-group-container]").first(),
			$subfamily_group = $product_family_group.find("[data-product-subfamily-list]");

		$subfamily_group.addClass("expand");
		$product_family_group.find(".more-container-product .material-icons").first().addClass("collapse");
	}

	/**
	 * SVG diagram click event handler
	 * @param e
	 */
	function SVGDiagramClickEventHandler(e) {
		e.stopPropagation();
		var $currtarget = $(e.currentTarget).parent(),
			$curr_url = $currtarget.attr("data-reference-link"),
			$diagram_box = $(".diagram-box"),
			linkid = $currtarget.attr("name"),
			lid = linkid ? linkid.split("&lid=")[1] : "",
			_idx = $currtarget.attr("class"),
			is_default = _idx ? _idx.indexOf("default") > -1 : false;


		if (linkid && $curr_url && !is_default) {
			$diagram_box
				.find("[class*='subsys default enabled']")
				.attr("class", "subsys enabled");

			$diagram_box
				.find("path[data-path-state='active']")
				.attr({
					"data-path-state": "",
					"class": "enabled"
				});

			$currtarget.attr("class", "subsys default enabled");
			$currtarget
				.find("path[data-path-state]")
				.attr({
					"data-path-state": "active"
				});

			buildAssociatedListContainer();
			buildRefDesignProductList({
				el: $currtarget,
				url: $curr_url,
				text: $currtarget.find("desc"),
				test: "from_buildDisplay"
			});

			//LinkID Click Event Handler for SVG Subsystem
			_tiAnalyticsTrack("Link Track", lid, tiPageName, tiContentGroup);
			var subsystem_id;
			if( $currtarget.attr("class") && !$currtarget.hasClass("subsys disabled")){
				subsystem_id = $currtarget.attr("data-subsystem-id");
			}
			setVariantUrl(document.getElementById("eeqId").value, subsystem_id, false );
		}
	}

	function SVGdiagramOnMouseEnterEventHandler(e) {
		e.stopPropagation();
		var $curr = $(e.currentTarget),
			$parent = $curr.closest("[data-reference-link]"),
			ref_link = $parent.data("reference-link"),
			_idx = $parent.attr("class"),
			is_default = _idx ? _idx.indexOf("default") > -1 : false;

		if (ref_link && !is_default) {
			$curr
				.closest("[data-reference-link]")
				.find("[data-path-state]")
				.attr("class", "enabled hover");
		}
	}

	function SVGdiagramOnMouseLeaveEventHandler(e) {
		e.stopPropagation();
		var $curr = $(e.currentTarget),
			$parent = $curr.closest("[data-reference-link]"),
			ref_link = $parent.data("reference-link"),
			_idx = $parent.attr("class"),
			is_default = _idx ? _idx.indexOf("default") > -1 : false;

		if (ref_link && !is_default) {
			$curr
				.closest("[data-reference-link]")
				.find("[data-path-state]")
				.attr("class", "enabled");
		}
	}

	/**
	 * Build HTML parent container for reference design & products list
	 */
	function buildAssociatedListContainer() {
		//Locates base shape of "subsystem" and adds data attribute to DOM elements for binding purposes
		var initContainer = function (i, txt) {
			var parent = $(txt).closest("g[transform]"),
				has_attr = parent.attr("data-ssname");

			if (!has_attr) {
				parent.attr("class", "subsys-text");
			} else {
				$(txt).parent().parent().attr("class", "subsys-text");
			}
		};

		$elem.find(".block-text").each(initContainer);

		if ($(".diagram-box").length < 1) {
			$(".diagram-main-container").html(base_layout);
		} else {
			if ($("[data-diagram-type='product-details']").length < 1) {
				$(base_layout).insertAfter($eerd_display.find(".diagram-box"));
			}
		}
	}

	/**
	 * Truncates and appends ellipsis on text string
	 * @param str
	 * @returns {*}
	 */
	function textTrim(str) {
		var result = [];

		result = str;
		result = result.split(" ");

		if (result.length > 40) {
			result = result.slice(0, 40);
			result = result.join(" ");
			result = result.replace(/<\/P>/g,"</p>");
			result = result.split("</p>");
			var length=result.length;
			if(length>1){
				if(result[length-1] == ""){
					result[length-2]=result[length-2]+"(...)";
					}
				else{
					result[length-1]=result[length-1]+"(...)";
					}
			result = result.join("</p>") ;
			}
			else{
				result = result.join(" ") + " " + "(...)"+"</p>";
			}
		} else {
			result = result.join(" ");
			if (result.length > 400) {
				result=result.substring(0, 400);
				result = result+ " " + "(...)"+"</p>";
			}
		}
		return result;
	}

	function getDisplayVersion(layout, version) {
		var _layout = layout.replace("{{diagram_container_title}}", (variantJSON && variantJSON.length > 1) ? Text.diagram_container.variantTitle : Text.diagram_container.title);

		$eerd_display
			.prepend(_layout)
			.attr("data-diagram-version", Version)
			.addClass("u-boxShadow-1")
			.addClass(version);
	}

	function bindDataToDiagramElem(i, d) {
		var group_name = d.subSystemEERDGroup.toLowerCase(),
			default_class = d.defaultSubSystem === "true" ? "default " : "",
			enabled_class = d.status === "enabled" ? "enabled" : "disabled",
			eeid = document.getElementById("eeqId").value,
			lnk = svcUrl.A1.productlist.replace("{{product_id}}", d.subSystemId),
			lid_region = Link_ID.region[Region],
			lid = Link_ID[Version].subsys
				.replace("{{linkid_region}}", lid_region)
				.replace("{{eename}}", eeid)
				.replace("{{subsysname}}", d.subSystemId),
			rdproducts_link = d.status === "enabled" ? lnk : "",
			assignGroups = function () {
				if ($(this).attr("id") === group_name) {
					$(this).attr({
						"data-default-subsystem": d.defaultSubSystem,
						"data-reference-link": rdproducts_link,
						"data-ssname": convertDataName(d.subSystemName),
						"data-subsystem-id": d.subSystemId,
						"class": "subsys " + default_class + enabled_class + " groupClass",
						"name": lid
					})
						.find("path").first()
						.attr({
							"data-path-state": "",
							"class": d.status
						});
				}
			};

		if (d.status === "disabled") {
			$("#" + d.subSystemEERDGroup + " " + ".component path").attr("class", "disabled");
			$("#" + d.subSystemEERDGroup + " " + ".component rect").attr("class", "disabled");
		}

		//Loops through each "subsystem block" g element and assigns data object pairs
		$("[data-diagram-target] svg > g > g").each(assignGroups);

		return i;
	}

	function assignAttrToComponentShapes() {
		var findComponentShapes = function () {
			var $this = $(this),
				subsys = $this.find("[data-path-state]"),
				is_disabled = !$this.attr("data-reference-link"),
				parent_block = $this.find("title:contains('Subsystem')").siblings("path"),
				rectangle = $this.find("title:contains('EERD1')").siblings("rect"),
				EERD1 = $this.find("title:contains('EERD1')").siblings("path");

			if (is_disabled) {

				if (subsys.length < 1) {
					$this.attr("class", "subsys disabled");
					parent_block.attr({
						"data-path-state": "",
						"class": "disabled"
					});
				}

				subsys.attr("class", "disabled");
				rectangle.attr("class", "disabled");
				EERD1.attr("class", "disabled");
			} else {
				rectangle.attr("class", "active");
				EERD1.attr("class", "active");
			}
			//check if variant subsystem is loaded in url and select it
			var url_ssid = getUrlParameter('subsystemid');
			var chk = $('[data-subsystem-id='+url_ssid+']').length;

			var $diagram_box = $(".diagram-box");
			if(chk > 0){

				if($this.attr("data-default-subsystem") === "false" && url_ssid === $this.attr("data-subsystem-id")){
					$diagram_box
						.find("[class*='subsys default enabled']")
						.attr("class", "subsys enabled");

					$diagram_box
						.find("path[data-path-state='active']")
						.attr({
							"data-path-state": "",
							"class": "enabled"
						});

					$this.attr("class", "subsys default enabled");
					$this
						.find("path[data-path-state]")
						.attr({
							"data-path-state": "active"
						});
				}
			}
		};

		$("[data-diagram-target] svg > g > g").each(findComponentShapes);
		setVariantUrlOnLoad();
	}

	var getUrlParameter = function (sParam) {
		var sPageURL = decodeURIComponent(window.location.search.substring(1)),
			sURLVariables = sPageURL.split('&'),
			sParameterName,
			i;

		for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split('=');

			if (sParameterName[0] === sParam) {
				return sParameterName[1] === undefined ? true : sParameterName[1];
			}
		}
	};

	function loadA1DisplayVersion() {
		if (variantJSON && variantJSON.length > 1) {
			buildA1VariantSelect();
		} else {
			Layout.A1.diagram_container = Layout.A1.diagram_container.replace("{{diagram_variant_select}}", "");
		}

		var diagramRetrievePrev = function () {
			getEERDDiagram(svcUrl.A1.diagram.file);
		};

		var subsysRetrievePrev = function () {
			getDiagramData(svcUrl.A1.diagram.subsyslist);
		};

		var getEERDDiagram = function (diag) {
				var diagram = diag.EndEquipmentReferenceDiagram || {};

				$eerd_display.find("[data-diagram-target]").html(diagram.svg);
				$eerd_display.find("[data-diagram-id]").attr({
					"data-diagram-id": diagram.eeqId,
					"data-eename": convertDataName(diagram.eeqName)
				});

				//Injects markup element for filter drop shadow effect
				$(Layout.dropshadow_filter).insertAfter($("[data-diagram-target]").find("svg style"));

			},
			getDiagramData = function (data) {
				var ee_subsys = data.EndEquipmentSubSystem || {};

				//Loops through each EndEquipmentSubSystem objects
				$.each(ee_subsys.subsystem, bindDataToDiagramElem);

				assignAttrToComponentShapes();
				loadSubSystemList();

				$eerd_display.find("svg > g").each(removeTitleElemContent);

				//jQuery Event Handlers
				$("[data-diagram-id] svg", document)
					.on("mouseenter", "g", SVGdiagramOnMouseEnterEventHandler)
					.on("mouseleave", "g", SVGdiagramOnMouseLeaveEventHandler)
					.on("click", "g", SVGDiagramClickEventHandler);

				//document.getElementsByClassName("legend-box")[0].children[0].innerHTML = "Select a subsystem for:"

			},
			/**
			 * Initial request that pulls data for svg element
			 */
			request = $.ajax({
				url: svcUrl.A1.diagram.file,
				dataType: "json",
				success: getEERDDiagram
			}),
			/**
			 * Secondary request that pulls in data related to svg elements
			 * @returns {*}
			 */
			chain = function () {
				return $.ajax({
					url: svcUrl.A1.diagram.subsyslist,
					dataType: "json",
					success: getDiagramData
				});
			},
			/**
			 * Removes tooltip from svg elements
			 */
			removeTitleElemContent = function () {
				$(this).find("title").text("");
			};

		getDisplayVersion(Layout.A1.diagram_container, "version-a1");

		//check if test
		if (Is_test === "test") {
			diagramRetrievePrev();
			subsysRetrievePrev();
		} else {
			$.when(request)
				.then(chain);
		}
	}

	function loadA2DisplayVersion() {
		if (variantJSON && variantJSON.length > 1) {
			buildA2VariantSelect();
		} else {
			Layout.A2.diagram_container = Layout.A2.diagram_container.replace("{{diagram_variant_select}}", "");
		}


		var diagram_container = Layout.A2.diagram_container
				.replace("{{diagram_container_title}}", (variantJSON && variantJSON.length > 1) ? Text.diagram_container.variantTitle : Text.diagram_container.title),

			getSubSystemListData = function (list) {
				var d = list.EndEquipmentSubSystem || {};

				if (d.errorCode === 137) {
					document.getElementById("eerd-display").innerHTML = document.getElementById("eerd-display").innerHTML + "THERE IS NO DATA";
				}

				if (d.subsystem && d.subsystem.length > 0) {
					$.each(subSystemListDataFormat(d.subsystem), buildA2SubsystemList);

					//check if variant subsystem is loaded in url and select it
					var url_ssid = getUrlParameter('subsystemid');
					var $sObj = $('[data-reference-link*='+url_ssid+']');

					if($sObj.length === 1){
						var ref_link = $sObj.attr("data-reference-link");
						if(ref_link !== undefined){
							var ss_id = ref_link.match("subsystemId/(.*)/rdproductlist")[1];
							var $dObj = $(".diagram-box").find("[class*='default']");

							if ($sObj.attr("class") !== "default" && url_ssid === ss_id) {
								$dObj.removeClass("default");
								$sObj.addClass("default");
							}
						}
					}
					setVariantUrlOnLoad();
				} else {
					$eerd_display.hide();
				}

			},
			request_subsystems = $.ajax({
				url: svcUrl.A2.subsyslist,
				dataType: "json",
				success: getSubSystemListData
			}),
			completion = function () {
				var idx = $eerd_display.find("[data-diagram-id] a.default"),
					_link = idx.data("reference-link");

				buildAssociatedListContainer();
				buildRefDesignProductList({
					el: idx,
					url: _link
				});

				$($eerd_display, document).find("ul li")
					.on("click", "a", subsystemListClickEventHandler);

			};

		getDisplayVersion(Layout.A2.diagram_container, "version-a2");
		$eerd_display.html(diagram_container);
		$.when(request_subsystems).then(completion);

	}

	function loadBDisplayVersion() {
		var diagram_list = Layout.diagram_list,
			idx = $eerd_display.find("li a.active"),
			_link = svcUrl.B.productlist;

		getDisplayVersion(Layout.B.box_body, "version-b");
		$eerd_display
			.addClass("version-b")
			.html(diagram_list);

		buildAssociatedListContainer();
		buildRefDesignProductList({
			el: idx,
			url: _link
		});
	}

	function descViewmoreManager() {
		var $show_more = $(".showMore"),
			$show_content = $show_more.find(".showContent"),
			$button = $show_more.find(".showButton"),
			$feature_desc_button = $("[data-event-action='desc-feature']"),
			_height,
			_max_height,
			showButtonClickEventHandler = function (e) {
				e.stopPropagation();
				var $curr = $(e.currentTarget),
					$parent = $curr.parent().parent().parent();

				if ($parent.hasClass("showMore")) {
					$parent.removeClass("showMore").addClass("showLess");
					$curr.siblings("i").addClass("collapse");
					$curr.parent().data("navtitle", "view less");
					$curr.text(Text.view_less);

				} else {
					$parent.removeClass("showLess").addClass("showMore");
					$curr.siblings("i").removeClass("collapse");
					$curr.parent().data("navtitle", "view more");
					$curr.text(Text.view_more);
				}

				//set the sticky header offset
				var offset = $(".ref-designs, .ti-products").offsetTop;
				$("#sticky").css("top", "" + offset + "px");
			};

		if ($show_content.length > 0) {
			_height = $show_content.height();
			_max_height = $show_content[0].scrollHeight;

			if ($feature_desc_button.length > 0) {
				$feature_desc_button.attr({
					"data-lid": "description",
					"data-navtitle": "view more"
				}).addClass("ga-track");
			}

			$button.find("span").html(Text.view_more).text();

		if (_max_height <= _height) {
				$feature_desc_button.addClass("hide");
			$button.addClass("hide");
		} else {
				$feature_desc_button.removeClass("hide");
			$button.removeClass("hide");
		}

		$($show_more, document).on("click", ".showButton span", showButtonClickEventHandler);
	}

	}

	function isArrayEmpty(array) {
		if (!array) return false;
		return array.filter(function (el) {
			return !$.isEmptyObject(el);
		}).length === 0;
	}

	/**
	 * Procedure to load predetermined flagged subsystem block related content
	 */
	function loadSubSystemList() {
		var $defaultElement = $(".diagram-box").find("[data-default-subsystem=true]");
		var defaultSSId = $defaultElement.attr("data-subsystem-id");
		var $target = $("[data-diagram-id]"),
			$svg = $target.find("svg"),
			$idx = $svg.find("g > g[class*='default']"),
			ref_link = $idx.attr("data-reference-link"),
			// trigger defaultSubsystemId If user tries to access with disabled subsystem id
			trigger = ref_link ? ref_link : "/wsapi/solution/subsystemId/"+defaultSSId+"/rdproductlist?lang=en";

		/*
		 * DC_SYSPATH-1340-fix-when-ss-is-disabled - If user tries to access reference design tab with disabled subsystemId, pass default subsystemId
		 * Do the css changes for default subsystem and disabled subsystem
		 */
		if(trigger.indexOf(defaultSSId) != -1){ //indexOf supports all browsers
			$idx.attr('class', '');
			$idx.attr('class', 'subsys disabled groupClass');
			$idx.find("path").first().attr("data-path-state", "");
			$defaultElement.attr("class","");
			$defaultElement.attr("class","subsys default enabled groupClass");
			$defaultElement.find("path").first().attr("data-path-state", "active");
		}

		buildAssociatedListContainer();
		buildRefDesignProductList({
			el: $idx,
			url: trigger
		});
	}

	function initEEDiagram() {
		if (Version === "A1") {
			loadA1DisplayVersion();
			descViewmoreManager();

		} else if (Version === "A2") {
			descViewmoreManager();
			loadA2DisplayVersion();

		} else if (Version === "B") {
			descViewmoreManager();
			loadBDisplayVersion();

		} else {
			descViewmoreManager();
			$eerd_display.hide();
			chapterNavManager();
		}
	}

	initEEDiagram();
};

var runPreview = function (theSVG, eeid, rgn, eerd_version, testCheck) {
	$.get(theSVG, function (svg) {
		var svgFile = svg;

		var preview_eerd_json = {
			"EndEquipmentReferenceDiagram": {
				"eeqId": 599,
				"eeqName": "Product Preview",
				"subsystemId": 0,
				"svg": svgFile
			}
		};

		var preview_subsys_json = {
			"EndEquipmentSubSystem": {
				"eeqId": 599,
				"eeqName": "Product Preview",
				"eeqUrl": "",
				"subsystemId": 0,
				"subsystem": JSON.parse(localStorage.getItem("jsonPass"))
			}
		};

		var _data = {
			A1: {
				diagram: {
					file: "/wsapi/solution/eeqId/" + eeid + "/eerd",
					subsyslist: "/wsapi/solution/eeqId/" + eeid + "/subsystemlist?lang=" + rgn + "&format=" + eerd_version,
					test_file: preview_eerd_json,
					test_subsyslist: preview_subsys_json
				},
				productlist: "/wsapi/solution/subsystemId/{{product_id}}/rdproductlist?lang=" + rgn,
				test_productlist: "preview_rdproductlist.json"
			},
			A2: {
				subsyslist: "/wsapi/solution/eeqId/" + eeid + "/subsystemlist?lang=" + rgn + "&format=" + eerd_version,
				productlist: "/wsapi/solution/subsystemId/{{product_id}}/rdproductlist?lang=" + rgn
			},
			B: {
				productlist: "/wsapi/solution/eeqId/" + eeid + "/rdproductlist?lang=" + rgn
			}
		};

		com.TI.diagramManager({
			id: "#eerd-display",
			display_version: eerd_version,
			region: rgn,
			ee: eeid,
			data: _data,
			config: com.TI.diagramManager.config("rd_prod_assets"),
			test: testCheck
		});

	}, 'text'); // end of $.get
};

var putDiagramOnPage = function () {
	var eeid = $("#eeqId").val(),
		rgn = $("#website").val(),
		eerd_version = $("#format").val(),
		_data;

	var testCheck = window.location.href.split('&')[1];
	if (testCheck && testCheck.split('=')[0] === 'isTest') {
		testCheck = testCheck.split('=')[1];

	}

	var svgName = window.location.href.split('?')[1];
	if (svgName && svgName.split('=')[0] === 'pathToSVG') {
		svgName = svgName.split('&')[0];
		svgName = svgName.split('=')[1];

	}

	//var svgFile;
	var preview_eerd_json;
	var preview_subsys_json;

	if (testCheck === 'test') {
		runPreview(svgName, eeid, rgn, eerd_version, testCheck);
	} else {
		_data = {
			A1: {
				diagram: {
					file: "/wsapi/solution/eeqId/" + eeid + "/eerd",
					subsyslist: "/wsapi/solution/eeqId/" + eeid + "/subsystemlist?lang=" + rgn + "&format=" + eerd_version,
					test_file: preview_eerd_json,
					test_subsyslist: preview_subsys_json
				},
				productlist: "/wsapi/solution/subsystemId/{{product_id}}/rdproductlist?lang=" + rgn,
				test_productlist: "preview_rdproductlist.json"
			},
			A2: {
				subsyslist: "/wsapi/solution/eeqId/" + eeid + "/subsystemlist?lang=" + rgn + "&format=" + eerd_version,
				productlist: "/wsapi/solution/subsystemId/{{product_id}}/rdproductlist?lang=" + rgn
			},
			B: {
				productlist: "/wsapi/solution/eeqId/" + eeid + "/rdproductlist?lang=" + rgn
			}
		};

		com.TI.diagramManager({
			id: "#eerd-display",
			display_version: eerd_version,
			region: rgn,
			ee: eeid,
			data: _data,
			config: com.TI.diagramManager.config("rd_prod_assets"),
			test: testCheck
		});
	}
};

function setVariantUrl(varId,ssId,load){
	var url = window.location.href;
	var aliasTrackingTag;

	// Deduce alias tracking tag
	if ((url.indexOf("?hqs") === -1 || url.indexOf("?HQS") === -1) && (url.indexOf("hqs") !== -1 || url.indexOf("HQS") !== -1)) {
		if(url.indexOf("hqs") !== -1)
			aliasTrackingTag = url.substr(url.indexOf("hqs"));
		else
			aliasTrackingTag = url.substr(url.indexOf("HQS"));
		if (aliasTrackingTag.indexOf("&") !== -1) {
			aliasTrackingTag = aliasTrackingTag.substr(0, aliasTrackingTag.indexOf("&"));
		}
	}

	if(url.indexOf("#") !== -1){
		url = url.substr(0,url.indexOf("#"));
	}
	if(url.indexOf("?") !== -1){
		url = url.substr(0,url.indexOf("?"));
	}

	if(varId && ssId && !load){
		url = url + "?variantid=" + varId + "&subsystemid=" + ssId;
		if (aliasTrackingTag) {
			url = url + "&" + aliasTrackingTag;
		}
		history.pushState(null,null,url);
	}

}

function setVariantUrlOnLoad() {
	var variant_id = document.getElementById("eeqId").value;
	var sschkA1 = $(".diagram-box").find("[class*='subsys default enabled']").attr("data-subsystem-id");
	var sschkA2 = $(".diagram-box").find("[class*='default']").attr("data-reference-link");
	var defaultSSID = $(".diagram-box").find("[data-default-subsystem=true]").attr("data-subsystem-id");
	var ss_id;
	if(window.location.href.indexOf('?variantid=') === -1){
		var load = true;
	}
	if (sschkA1){
		ss_id = sschkA1;
	} else if (sschkA2) {
		ss_id = sschkA2.match("subsystemId/(.*)/rdproductlist")[1];
	}
	/*
	 * DC_SYSPATH-1340-fix-when-ss-is-disabled
	 * Pass default subsystem id when user tries to access disabled subsystemId
	 */
	if (sschkA2 == "") {
		ss_id=defaultSSID;
	}
	setVariantUrl(variant_id, ss_id, load);

	function findPos(obj) {
		var curtop = 0;
		if (obj.offsetParent) {
			do {
				curtop += obj.offsetTop;
			} while (obj = obj.offsetParent);
			return [curtop];
		}
	}

    window.onbeforeunload = function () {
    var elmnt = document.querySelector("a[name='referencedesigns']");
        if( !load && elmnt !== null && elmnt !== undefined ){
        window.scroll(0,findPos(elmnt)-120);
        }
    }
}


jQuery(document).ready(function () {
	var variantList = document.getElementById("variantsList");

	function checkAnalytics(retryCount) {
		if (typeof _tiAnalyticsTrack !== "undefined") {
			_tiAnalyticsTrack('eerd', 'variant default', $("#website").val() + "_eerd_" + variantList[0].vId + "_variant_default");
		} else {
			if (retryCount < 5) {
				retryCount++;
				setTimeout(function () {
					checkAnalytics(retryCount);
				}, 1250);
			}
		}
	}

	if (variantList && variantList.value !== "") {
		variantJSON = JSON.parse(variantList.value);

		variantList = JSON.parse(variantList.value);
		variantList = variantList.filter(function (e) {
			return e.format;
		});

		document.getElementById("eeqId").value = "" + variantList[0].vId;
		document.getElementById("format").value = variantList[0].format;

		checkAnalytics(0);

	}
	putDiagramOnPage();

	/** TODO upcoming sprint
	 * Temporarily adding event handler for new SDK diagram section in product folder.
	 * This will be added into API during code refactoring and cleanup.
	 */
	var $sdk_teal_container = $(".sdk-teal-container"),
		sdkClickEventHandler = function (e) {
			e.stopPropagation();
			e.preventDefault();
			var $el = $(e.currentTarget),
				$row = $el.closest(".lvl.primary"),
				$target = $row.siblings(".lvl.secondary"),
				$cell_row = $row.parent(),
				lid = $el.data("lid");

			if (!$target.hasClass("show")) {
				lid = lid.replace("expand", "collapse");
				$target.addClass("show");
				$cell_row.addClass("expanded");
				$el.data("lid", lid);

			} else {
				lid = lid.replace("collapse", "expand");
				$target.removeClass("show");
				$cell_row.removeClass("expanded");
				$el.data("lid", lid);
			}

			if ($el.find(".material-icons").text() === "expand_more" || $el.siblings().find(".material-icons").text() === "expand_more") {
				$el.find(".material-icons").text("expand_less");
				$el.siblings().find(".material-icons").text("expand_less");
				setTimeout(function () {
					$target.css({
						"overflow": "visible",
						"height": "auto"
					});
				}, 200);
			} else {
				$el.find(".material-icons").text("expand_more");
				$el.siblings().find(".material-icons").text("expand_more");
				$target.css({
					"overflow": "hidden",
					"height": "0"
				});
			}
		};
	if ($sdk_teal_container && $sdk_teal_container.length > 0) {
		$(".sdk-teal-container", document)
			.on("click", ".top-desc", sdkClickEventHandler)
			.on("click", ".more-container a", sdkClickEventHandler);
	}
});
